/* ============================================================================
 * SkinArt — an art <img> that wears the active skin
 * ----------------------------------------------------------------------------
 * One place owns the two rules the whole shell needs:
 *
 *   1. resolve the master path to the skin's compiled file (src/lib/skinAssets);
 *   2. fall back to the master file if that skin has no variant of THIS one —
 *      a brand mark, or a sprite a fork has not been recompiled for.
 *
 * The fallback is remembered against the SKIN it failed on, not as a bare
 * boolean: a boolean would keep a tile on the master colour after a skin swap.
 * ========================================================================= */

import { useState, type ImgHTMLAttributes } from 'react';
import { useAppearance } from './AppearanceProvider';
import { skinArt } from '../lib/skinAssets';

type Props = ImgHTMLAttributes<HTMLImageElement> & {
  /** A MASTER path, e.g. /logos/dock-embassy.png or /pixel/led-ok.png */
  src: string;
};

export function SkinArt({ src, onError, ...rest }: Props) {
  const { skin } = useAppearance();
  const [fellBackOn, setFellBackOn] = useState<string | null>(null);
  const resolved = fellBackOn === skin ? src : skinArt(src, skin);

  return (
    <img
      {...rest}
      src={resolved}
      onError={(e) => {
        if (fellBackOn !== skin) setFellBackOn(skin);
        onError?.(e);
      }}
    />
  );
}
